// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "javascript/chunks/" + "050df7a4d16fd6907680" + ".min.js";
};